import React from "react";

export const LinearProgressIndicator = ({
  max,
  current,
  title,
  textStyle,
  isOpac,
  showChecked,
}) => {
  const width = (current * 100) / max;

  const container = {
      textAlign: "center",
      paddingTop: "8px",
      paddingBottom: "8px",
      width: "100%",
    },
    titleStyle = {
      textAlign: "center",
      fontSize: 16,
      marginBottom: 5,
    }

  const renderTitle = () => {
    if (showChecked) {
      return (
        <div style={{ display: "inline-flex" }}>
          {title && <p style={{ ...titleStyle, ...textStyle }}>{title}</p>}
          <i className="fa fa-check-circle phase-check" />
      </div>
      )
    }

    if (title) {
      return (<p style={{ ...titleStyle, ...textStyle }}>{title}</p>)
    }

    return null;
  }

  return (
    <div style={container}>
      {renderTitle()}
      <div
        style={{
          backgroundColor: "#d3d3d3",
          borderRadius: "13px",
          width: "100%",
          opacity: isOpac ? 0.5 : 1
        }}
      >
        <div
          style={{
            backgroundColor: "#4658ba",
            width: width + "%",
            height: "10px",
            borderRadius: "10px",
            opacity: isOpac ? 0.5 : 1
          }}
        />
      </div>
    </div>
  );
};
